/** @format */

import { hasActionPermission } from './permission'; // 权限判断指令
import { isFirefox } from '@/utils/browser';
// import { dateFormat } from '@/filters/index'
import { $utils } from '@/utils/publicUtils';
const defaultRowHandleEffect = 'hover';

export default {
	props: {
		/**
		 * @description 管理列
		 */
		rowHandle: {
			type: Object,
			default: null,
		},
		// 管理列样式
		manageStyle: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			bodyWrapper: null,
		};
	},
	computed: {
		// 显示效果
		rowHandleEffect() {
			// default ||  display || 'hover'
			return this.rowHandle ? this.rowHandle.effect || defaultRowHandleEffect : defaultRowHandleEffect;
		},
		rowHandleButtonNumber() {
			if (!this.rowHandle) return 3;
			return $utils.isNotEmpty(this.rowHandle.buttonNumber) ? this.rowHandle.buttonNumber : 3;
		},
		rowHandleActions() {
			if (!this.rowHandle || !this.rowHandle.actions) return [];
			return this.rowHandle.actions || [];
		},
		rowHandleDefaultWidth() {
			if (this.rowHandleEffect === 'display') {
				return this.rowHandleButtonNumber * 70 + 50;
			} else {
				return this.$i18n.locale === 'en' ? 75 : 50;
			}
		},
		hasToolbars() {
			if ($utils.isEmpty(this.toolbars)) {
				return false;
			}
			for (let i = 0; i < this.toolbars.length; i++) {
				const toolbar = this.toolbars[i];
				// 备注：权限问题，先注释掉
				const permission = hasActionPermission(toolbar, this.identity);
				if (permission) return true;
			}
			return false;
		},
		manageButtonWidth() {
			if (this.rowHandle) {
				if ($utils.isNotEmpty(this.rowHandle.width)) {
					return this.rowHandle.width;
				}
				if (this.rowHandle.buttonNumber < 3) {
					return 120;
				} else if (!this.manageStyle) {
					return 160;
				} else {
					return 180;
				}
				// return this.rowHandle.buttonNumber < 2 && this.$t('common.table.operation').length < 4 ? 80 : (this.displayField && !this.manageStyle) ? 160 : 38
			}
		},
	},
	mounted() {
		// 监听鼠标滚动事件 this.$refs['ibpsCrud'].childNodes[1].firstChild.childNodes[2]
		this.$nextTick(() => {
			this.bodyWrapper = this.getBodyWrapper();
			if (this.bodyWrapper) {
				this.bodyWrapper.addEventListener('scroll', this.debounce(this.handleScroll, 380));
			}
		});
	},
	beforeUnmount() {
		if (this.bodyWrapper) {
			this.bodyWrapper.removeEventListener('scroll', this.handleScroll);
			this.bodyWrapper = null;
		}
	},
	methods: {
		customToolbarsMain(label, column) {
			let resultNum = null;
			if (column.dateFormat) {
				// resultNum = dateFormat(label, column.dateFormat, column.origDateFormat);
			} else if (column.options) {
				resultNum = this.handleColumnOptions('label', column.options, label);
			} else {
				resultNum = label;
			}
			const detailOpen = [];
			const obj = {
				code: 'detail',
				label: resultNum,
			};
			detailOpen.push(obj);
			return detailOpen;
		},
		getBtnActions(toolbars) {
			if (!toolbars) return [];
			const btnActions = [];
			for (let i = 0; i < toolbars.length; i++) {
				const actionBtn = toolbars[i];
				if (hasActionPermission(actionBtn, this.identity)) {
					btnActions.push(actionBtn);
				}
			}
			return btnActions;
		},
		getRowActions(row) {
			if (!this.rowHandleActions) return [];
			const rowActions = [];
			for (let i = 0; i < this.rowHandleActions.length; i++) {
				const action = this.rowHandleActions[i];
				if (this.handleActionHidden(action.hidden, row) && hasActionPermission(action, this.identity)) {
					rowActions.push(action);
				}
			}
			return rowActions;
		},
		getRowHandleActions(row, more = false) {
			const actions = this.getRowActions(row);
			if (actions.length > this.rowHandleButtonNumber) {
				const first = this.rowHandleButtonNumber - 1;
				return more ? actions.slice(first, actions.length) : actions.slice(0, first);
			} else if (actions.length === this.rowHandleButtonNumber) {
				return more ? null : actions.slice(0, this.rowHandleButtonNumber);
			} else {
				return more ? null : actions;
			}
		},
		getRowHandleMoreActions(row) {
			return this.getRowHandleActions(row, true);
		},
		/**
		 * 是否有更多按钮
		 * @param {*} row
		 * @returns
		 */
		hasRowHandleMoreActions(row) {
			const rowActions = this.getRowHandleMoreActions(row);
			if (!rowActions) return false;
			return rowActions.length > 0;
		},
		/**
		 * 是否有按钮
		 * @param {*} row  行的数据
		 */
		hasRowHandleActions(row) {
			const rowActions = this.getRowActions(row);
			if ($utils.isEmpty(rowActions)) {
				return false;
			}
			return true;
		},
		/**
		 * 处理按钮隐藏，显示
		 */
		handleActionHidden(hidden = false, row) {
			let isHidden = !hidden;
			if (typeof hidden === 'boolean') {
				isHidden = !hidden;
			} else if (typeof hidden === 'function') {
				isHidden = !hidden.call(this, row, this.ibpsData);
			}
			return isHidden;
		},
		handleScroll() {
			this.handleAnimationFrame(() => {
				const menu = this.getMenus();
				if (menu) {
					menu.style.display = 'block';
				}
			});
		},
		// 防抖
		debounce(fn, wait) {
			let menu;
			this.handleAnimationFrame(() => {
				menu = this.getMenus();
			});
			let timeout;
			return function () {
				if (timeout) clearTimeout(timeout);
				if (menu) {
					menu.style.display = 'none';
				}
				timeout = setTimeout(fn, wait);
			};
		},
		/**
		 * 处理管理列隐藏,显示
		 */
		handleOperationMenuEnter(row, column, cell) {
			this.handleAnimationFrame(() => {
				// 行数据
				this.currentRow = row;
				// 获取当前行索引
				this.currentRowIndex = this.getCurrentRowIndex(row);
				// 管理菜单
				const menu = this.getMenus();
				if (!menu) {
					return;
				}
				// 列表含有X轴滚动条则留出管理列位置
				/* if ((cell.offsetParent.scrollWidth - 10) > (cell.offsetParent.clientWidth + cell.offsetParent.scrollLeft) && this.rowHandleActions.length > 0 && this.displayField) {
          menu.style.borderRight = '35.5px solid white'
        } else {
          menu.style.borderRight = 'none'
        } */
				// 列表含有Y轴滚动条则留出滚动条位置

				const bodyWrapper = this.getBodyWrapper();
				const bodyScrollTop = bodyWrapper ? bodyWrapper.scrollTop : 0;
				const bodyOffsetTop = bodyWrapper ? bodyWrapper.offsetTop : 0;
				const bodyOffsetHeight = bodyWrapper ? bodyWrapper.offsetHeight : 0;
				const cellOffsetParent = cell.offsetParent || {};
				const cellOffsetTop = cell.offsetTop;
				const cellOffsetHeight = cell.offsetHeight;
				// 离表格顶部高度
				menu.style.top = `${cellOffsetTop - bodyScrollTop + bodyOffsetTop}px`;
				// 管理列菜单高度
				menu.style.height = `${cell.clientHeight}px`;
				// 列表含有Y轴滚动条则留出滚动条位置
				menu.style.right = cellOffsetParent.scrollHeight > cellOffsetParent.clientHeight ? '8px' : '0px';

				// 第一行和最后一行若不完全显示则不显示管理菜单
				if (
					cellOffsetTop - bodyScrollTop >= 0 &&
					cellOffsetTop + cellOffsetHeight <= bodyScrollTop + bodyOffsetHeight
				) {
					menu.style.display = 'block';
				} else {
					menu.style.display = 'none';
				}
			});
		},
		getCurrentRowIndex(row) {
			if ($utils.isEmpty(row) || $utils.isEmpty(this.ibpsData)) {
				return null;
			}
			const pkValue = this.getPkValue(row);
			for (let i = 0; i < this.ibpsData.length; i++) {
				const item = this.ibpsData[i];
				if (this.getPkValue(item) === pkValue) {
					return i;
				}
			}
		},
		getBodyWrapper() {
			if (this.$refs.elTable && this.$refs.elTable.$refs.bodyWrapper) {
				return this.$refs.elTable.$refs.bodyWrapper;
			}
			return;
		},
		getMenus() {
			return this.$refs.menus;
		},
		handleOperationMenuLeave(row, column, cell, event) {
			// 备注：以下是正确的代码
			setTimeout(() => {
				const bodyWrapper = this.getBodyWrapper();
				if (!bodyWrapper) {
					return;
				}
				const tds = bodyWrapper.querySelectorAll('.el-table__row');
				if (tds && this.visible) {
					tds[this.currentRowIndex].classList.add('hover-row');
				}
			}, 50);

			this.handleAnimationFrame(() => {
				const menu = this.getMenus();
				if (!menu) return;
				if (
					event.layerY <= 0 ||
					event.layerX < 0 ||
					(isFirefox() ? event.layerX > 35 : false) ||
					event.layerY >= cell.clientHeight
				) {
					menu.style.display = 'none';
				}
			});
		},
		handleAnimationFrame(callback) {
			let raf = window.requestAnimationFrame;
			if (!raf) {
				raf = (fn) => setTimeout(fn, 16);
			}
			raf(() => {
				setTimeout(callback, 50);
			});
		},
		handleMouseEnter() {
			this.onMenucon = false;
			setTimeout(() => {
				const bodyWrapper = this.getBodyWrapper();
				if (!bodyWrapper) {
					return;
				}
				const tds = bodyWrapper.querySelectorAll('.el-table__row');
				if (tds) {
					tds[this.currentRowIndex].classList.add('hover-row');
				}
			}, 16);
		},
		handleMouseLeave() {
			if (this.visible) {
				this.onMenucon = true;
			} else {
				setTimeout(() => {
					const bodyWrapper = this.getBodyWrapper();
					if (!bodyWrapper) {
						return;
					}
					const tds = bodyWrapper.querySelectorAll('.el-table__row');
					if (tds && !this.visible) {
						tds[this.currentRowIndex].classList.remove('hover-row');
					}
				}, 20);
			}
		},
		visibleChange(visible) {
			this.visible = visible;
			const menu = this.getMenus();
			const bodyWrapper = this.getBodyWrapper();
			if (!bodyWrapper || !menu) {
				return;
			}
			const tds = bodyWrapper.querySelectorAll('.el-table__row');
			if (tds && this.visible) {
				tds[this.currentRowIndex].classList.add('hover-row');
			} else {
				if (this.onMenucon) {
					this.onMenucon = false;
					menu.style.display = 'none';
					tds[this.currentRowIndex].classList.remove('hover-row');
				}
			}
		},
		handleActionClick() {
			// const menu = this.getMenus()
			// menu.style.display = 'none'
		},
	},
};
